import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedCustomer: null
};

export const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setSelectedCustomer: (state, action) => {
            state.selectedCustomer = action.payload;
        },
        clearSelectedCustomer: (state) => {
            state.selectedCustomer = null;
        },
        updateCustomerRole: (state, action) => {
            if (state.selectedCustomer && state.selectedCustomer.id === action.payload.customerId) {
                state.selectedCustomer = {
                    ...state.selectedCustomer,
                    role: {
                        ...state.selectedCustomer.role,
                        title: action.payload.newRoleTitle
                    }
                };
            }
        }
    }
});

export const { setSelectedCustomer, clearSelectedCustomer, updateCustomerRole } = customerSlice.actions;
export default customerSlice.reducer;
